import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';

import ConfirmationModal from '~/components/ConfirmationModal';
import commonMessages from '~/containers/App/messages';
import Spacings from '~/modules/ui-kit/spacings';
import { useTheme } from '@mui/material';
import { useCancelShift } from '~/hooks/api/useCancelShift';
import messages from './messages';

type ShiftCancellationButtonProps = {
  shiftId: number;
};

const ShiftCancellationButton = (props: ShiftCancellationButtonProps) => {
  const theme = useTheme();
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const [isCancellationDialogVisible, setCancellationDialogVisibility] =
    useState(false);
  const [cancellationReason, setCancellationReason] = useState('');
  const cancelShiftMutation = useCancelShift({
    onError() {
      showSnackbar({
        message: intl.formatMessage(messages.cancellationFailure),
      });
    },
    onSuccess() {
      showSnackbar({
        message: intl.formatMessage(messages.cancellationSuccess),
      });
      setCancellationDialogVisibility(false);
    },
  });
  return (
    <>
      <Button
        variant="contained"
        style={{
          backgroundColor: theme.palette.error.dark,
          color: 'white',
        }}
        onClick={() => setCancellationDialogVisibility(true)}
      >
        {cancelShiftMutation.isPending ? (
          <FormattedMessage {...commonMessages.loading} />
        ) : (
          <FormattedMessage {...messages.cancelShift} />
        )}
      </Button>
      <ConfirmationModal
        open={isCancellationDialogVisible}
        title={intl.formatMessage(messages.confirmCancellationTitle)}
        text={
          <Spacings.Stack scale="m">
            <div>
              <FormattedMessage {...messages.confirmCancellationDescription} />
            </div>
            <div>
              <TextField
                variant="standard"
                id="shift-cancellation-reason"
                onChange={(event) => setCancellationReason(event.target.value)}
                label={intl.formatMessage(messages.cancellationLabel)}
                fullWidth
              />
            </div>
          </Spacings.Stack>
        }
        confirmLabel={<FormattedMessage {...messages.confirmCancellation} />}
        cancelLabel={<FormattedMessage {...messages.cancelCancellation} />}
        onCancel={() => setCancellationDialogVisibility(false)}
        onConfirm={() => {
          cancelShiftMutation.mutate({
            id: props.shiftId,
            cancellationReason,
          });
        }}
      />
    </>
  );
};

export default ShiftCancellationButton;
